import React from 'react';
import { Container, Row, Col, ListGroup, Badge } from 'react-bootstrap';
import API from '../API'
import Nav from '../Components/Nav'

export default class Sent extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      messages: []
    }
  }

  componentDidMount() {
    API.messages().then(messages => {
      this.setState({ messages: messages })
    }, error => {
      // TODO: handle error
    })
  }

  render() {

    const MessagesComponent = this.state.messages.map((item, index) => {
      console.log(item.date)

      const Recipients = (props) => {
        console.log(item)

        if(!item.groups){
          return (null)
        }

        return item.groups.map(group=>{
          return (<Badge variant="secondary" style = {{marginRight:10}}>{group.name}</Badge>)
        })
      }

      return (
        <ListGroup.Item key={index} style={{ textAlign: "left" }}>
          
          <p><strong>Date:</strong> {new Date(parseInt(item.date)).toLocaleDateString("en-US")}</p>
         
          <p><strong>Recipients: <Recipients /> </strong></p>
            
          <p>{item.body}</p>
        
        </ListGroup.Item>
      )
    })

    return (
      <Container fluid>
        <Row>
          <Nav />
          <Col>
            <h3 style={{ padding: 10 }}>Sent Messages</h3>
            <ListGroup>
              {MessagesComponent}
            </ListGroup>
          </Col>
        </Row>
      </Container>
    )
  }
}